import { render, staticRenderFns } from "./VideoSequence.vue?vue&type=template&id=01057f92&scoped=true&"
import script from "./VideoSequence.vue?vue&type=script&lang=js&"
export * from "./VideoSequence.vue?vue&type=script&lang=js&"
import style0 from "./VideoSequence.vue?vue&type=style&index=0&id=01057f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01057f92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01057f92')) {
      api.createRecord('01057f92', component.options)
    } else {
      api.reload('01057f92', component.options)
    }
    module.hot.accept("./VideoSequence.vue?vue&type=template&id=01057f92&scoped=true&", function () {
      api.rerender('01057f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoSequence.vue"
export default component.exports